import React from 'react';

import { env } from '../../../../../../../environment';

import './style.scss';

interface WinnersCardProps {
  date: string;
  title: string;
  amount: string;
  playerId: string;
  currency: string;
  thumbnail: string;
  hasReplay: boolean;
  multiplier: string;
  showThumbnail: boolean;
  onCardClick: () => void;
  onReplayClick: () => void;
}

export const WinnersCard: React.FC<WinnersCardProps> = ({
  date,
  title,
  amount,
  currency,
  playerId,
  thumbnail,
  hasReplay,
  multiplier,
  showThumbnail,
  onCardClick,
  onReplayClick
}) => {
  return (
    <div className="winnersCard" onClick={onCardClick}>
      {
        showThumbnail && (
          <div className="winnersCardGameImg">
            <img src={`${env.filesUrl}/${thumbnail}`} alt="game" className="winnersCardGameImg" />
          </div>
        )
      }
      <div className="winnersCardInfo">
        <h3 className="winnersCardTitle">{title}</h3>
        <p className="winnersCardId">ID: {playerId}</p>
        <p className="winnersCardDate">{date}</p>
      </div>

      <div className="winnersCardStats">
        <span className="winnersCardMultiplier">{multiplier}</span>
        <span className="winnersCardAmount">
          {amount} <span className="winnersCardCurrency">{currency}</span>
        </span>
      </div>

      {hasReplay && (
        <button
          type="button"
          className="winnersCardBtn"
          onClick={(event) => {
            event.stopPropagation();
            onReplayClick();
          }}
          aria-label="replay"
        >
          <i className="icon-replay-cards winnersCardBtnIcon" />
        </button>
      )}
    </div>
  );
};

